import { createSelector } from 'reselect';


const getHotkeyTmpState = createSelector(
  [
    (state) => state.hotkey_template
  ],
  (state) => state
);


export const getTemplateState = createSelector(
  [
    getHotkeyTmpState
  ],
  (state) => state.template || {}
);


export const getTemplateId = createSelector(
  [
    getTemplateState
  ],
  (template) => template.id || null
);


export const getTemplateReferenceId = createSelector(
  [
    getTemplateState
  ],
  (template) => template.reference_id || null
);


export const getTemplateActiveStatus = createSelector(
  [
    getTemplateState
  ],
  (template) => template.active || false
);


export const getTemplateName = createSelector(
  [
    getTemplateState
  ],
  (template) => template.name || ""
);
